var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_312_4190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16.3137L11.5115 11.0811L23.023 16.3137L11.5115 20.4999L0 16.3137Z",
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.144355 10.4151L-0.921986 10.7686L-0.119217 11.0605L11.3923 15.2467L11.5115 15.29L11.6307 15.2467L23.1423 11.0605L23.945 10.7686L23.1674 10.4151L11.6559 5.18243L11.5115 5.11681L11.3672 5.18243L-0.144355 10.4151Z",
    fill: "#5E5E5E",
    stroke: "white",
    strokeWidth: 0.697679
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_312_4190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy_icon.fb39b10b973e8ae0cd1590ff131ed22c.svg";
export { ForwardRef as ReactComponent };